import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { SortableTable } from 'common/components/SortableTable';
import { getTokenBalances } from './actions/getTokenBalances';

// Admin read-only panel: per-sponsor token entitlement usage (eng/tech alloc/used/
// remaining) — replaces god-moding into a sponsor just to check their balances.
const TABLE_HEADERS = [
  { id: 'name', align: 'left', numeric: false, label: 'SPONSOR' },
  { id: 'email', align: 'left', numeric: false, label: 'EMAIL' },
  { id: 'engAllocated', align: 'right', numeric: true, label: 'ENG ALLOC' },
  { id: 'engUsed', align: 'right', numeric: true, label: 'ENG USED' },
  { id: 'engRemaining', align: 'right', numeric: true, label: 'ENG REMAIN' },
  { id: 'techAllocated', align: 'right', numeric: true, label: 'TECH ALLOC' },
  { id: 'techUsed', align: 'right', numeric: true, label: 'TECH USED' },
  { id: 'techRemaining', align: 'right', numeric: true, label: 'TECH REMAIN' },
];

function createData(row) {
  return [
    { id: 'name', value: row.name },
    { id: 'email', value: row.email },
    { id: 'engAllocated', value: row.eng.allocated, align: 'right' },
    { id: 'engUsed', value: row.eng.used, align: 'right' },
    { id: 'engRemaining', value: row.eng.remaining, align: 'right' },
    { id: 'techAllocated', value: row.tech.allocated, align: 'right' },
    { id: 'techUsed', value: row.tech.used, align: 'right' },
    { id: 'techRemaining', value: row.tech.remaining, align: 'right' },
  ];
}

const TokenBalances = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let mounted = true;
    getTokenBalances().then((sponsors) => {
      if (mounted) setRows(sponsors.map(createData));
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Grid item xs={12}>
      <Typography variant="h5" style={{ marginTop: 16, marginBottom: 8 }}>
        Token Balances
      </Typography>
      <SortableTable
        name="token-balances"
        headers={TABLE_HEADERS}
        rows={rows}
        defaultSortColumnIndex={0}
        searchable
        searchColumnName="name"
      />
    </Grid>
  );
};

export default TokenBalances;
